<script setup>
import SectionHeader from "../texts/SectionHeader.vue";
import CustomerDetailsCard from "../customer/CustomerDetailsCard.vue";
</script>

<template>
    <div class="align-center">
        <SectionHeader label="Customer Details" />

        <CustomerDetailsCard class="mt-2" />
    </div>
</template>
